/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import WordService from "@/services/WordService";
import { root } from "@/common/consts";

const filterSourceByAntonyms = source => {
    source.partsOfSpeech.forEach(pos => {
        pos.definitions = pos.definitions.filter(definition => {
            definition.synonyms = [];

            return definition.antonyms.length;
        });
    });

    source.partsOfSpeech = source.partsOfSpeech.filter(pos => pos.definitions.length);

    return source;
};

export default {
    state: {
        filters: {
            pos: [],
            additional: ["commonFilter", "uniqueFilter"]
        },
        isPosFilterActive: false,
        isAZFilterActive: false,
        isAntonymFilterActive: false,
        thesaurusHeadword: "",
        thesaurus: {},
        filteredThesaurus: {},
        sortedAZThesaurus: {},
        isThesaurusLoaded: false
    },
    actions: {
        loadThesaurus({ commit }, data) {
            commit("resetThesaurusFlag");

            WordService.getThesaurus(data.slug)
                .then(response => {
                    const sources = Object.values(response.thesaurus);
                    let posFilters = [];

                    sources.forEach(source => {
                        source.partsOfSpeech.forEach(pos => {
                            posFilters.push(pos.pos);
                        });
                    });

                    commit("setPosFilters", posFilters);
                    commit("setThesaurus", response.thesaurus);
                    commit("setSortedAZThesaurus", response.thesaurus);
                    commit("setThesaurusHeadword", response.headword || response.slug);
                    commit("initAntonymFilter");
                })
                .catch(err => {
                    // Add meta tag with property robots=noindex
                    const firstMeta = document.getElementsByTagName("meta")[0];
                    const metaRobots = document.createElement("meta");
                    metaRobots.setAttribute("name", "robots");
                    metaRobots.setAttribute("content", "noindex");
                    firstMeta.parentNode.insertBefore(metaRobots, firstMeta);

                    if (typeof window.__PRERENDER_INJECTED !== "undefined") {
                        window.document.dispatchEvent(
                            new CustomEvent("spa-render-404", {
                                detail: { component: data.component }
                            })
                        );
                        return;
                    }

                    /**
                     * Eject the user to the 404 No Results page
                     * if we don't have results for this word
                     */
                    window.location.assign(`${root.THESAURUS}/404/no-results`);
                });
        },
        filterThesaurus({ commit, state }, filtersArr) {
            commit("refreshFilteredThesaurus");
            commit("setSortedAZThesaurus", JSON.parse(JSON.stringify(state.filteredThesaurus)));
            commit("activateAntonymFilter", filtersArr.includes("antonymFilter"));

            if (filtersArr.length) {
                commit("activatePosFilter", true);

                filtersArr.forEach(filter => {
                    switch (filter) {
                        case "commonFilter":
                        case "uniqueFilter":
                            if (
                                filtersArr.includes("commonFilter") &&
                                filtersArr.includes("uniqueFilter")
                            ) {
                                break;
                            } else if (filtersArr.includes("commonFilter")) {
                                commit("applyUniqueWordsFilter", true);
                            } else if (filtersArr.includes("uniqueFilter")) {
                                commit("applyUniqueWordsFilter", false);
                            }
                            break;
                        case "antonymFilter":
                            commit("applyAntonymFilter");
                            break;
                        default:
                            commit("applyPosFilter", filtersArr);
                    }
                });

                commit("setSortedAZThesaurus", JSON.parse(JSON.stringify(state.filteredThesaurus)));
            } else {
                commit("activatePosFilter", false);
            }
        },
        showAZSortedThesaurus({ commit }, isActive) {
            commit("activateAZFilter", isActive);
        }
    },
    mutations: {
        resetThesaurusFlag(state) {
            state.isThesaurusLoaded = false;
        },
        setThesaurusHeadword(state, headword) {
            state.thesaurusHeadword = headword;
        },
        setThesaurus(state, thesaurus) {
            state.thesaurus = JSON.parse(JSON.stringify(thesaurus));
            state.filteredThesaurus = JSON.parse(JSON.stringify(thesaurus));
            state.isThesaurusLoaded = true;
        },
        setSortedAZThesaurus(state, thesaurus) {
            const sortedThesaurus = {
                /*
                source: {
                    partsOfSpeech: [
                        {
                            definitions: [
                                {
                                    synonyms: []
                                }
                            ]
                            pos: ""
                        }
                    ]
                    copyright: ""
                }
            */
            };

            for (let source in thesaurus) {
                sortedThesaurus[source] = {};
                sortedThesaurus[source].copyright = thesaurus[source].copyright;
                sortedThesaurus[source].partsOfSpeech = [];

                let posArr = [];

                thesaurus[source].partsOfSpeech.forEach(pos => posArr.push(pos.pos));

                posArr = new Set(posArr);

                posArr.forEach(pos => {
                    let posObj = {
                        definitions: [
                            {
                                synonyms: []
                            }
                        ],
                        pos
                    };

                    thesaurus[source].partsOfSpeech.forEach(thesaurusPos => {
                        if (pos === thesaurusPos.pos) {
                            thesaurusPos.definitions.forEach(definition => {
                                const { partOfSpeech, sense } = definition;

                                definition.synonyms.forEach(synonym =>
                                    posObj.definitions[0].synonyms.push({
                                        partOfSpeech,
                                        sense,
                                        ...synonym
                                    })
                                );
                            });
                        }
                    });

                    posObj.definitions[0].synonyms.sort((a, b) => {
                        if (a.word.slug > b.word.slug) {
                            return 1;
                        }
                        if (a.word.slug < b.word.slug) {
                            return -1;
                        }
                        return 0;
                    });

                    sortedThesaurus[source].partsOfSpeech.push(posObj);
                });
            }

            state.sortedAZThesaurus = JSON.parse(JSON.stringify(sortedThesaurus));
        },
        refreshFilteredThesaurus(state) {
            state.filteredThesaurus = JSON.parse(JSON.stringify(state.thesaurus));
        },
        setPosFilters(state, filters) {
            state.filters.pos = [...new Set(filters)];
        },
        activatePosFilter(state, isActive) {
            state.isPosFilterActive = isActive;
        },
        activateAZFilter(state, isActive) {
            state.isAZFilterActive = isActive;
        },
        activateAntonymFilter(state, isActive) {
            if (isActive) state.isAZFilterActive = false;

            state.isAntonymFilterActive = isActive;
        },
        applyPosFilter(state, partsOfSpeech) {
            const ft = JSON.parse(JSON.stringify(state.filteredThesaurus));

            for (let source in ft) {
                ft[source].partsOfSpeech = ft[source].partsOfSpeech.filter(pos =>
                    partsOfSpeech.includes(pos.pos)
                );

                if (!ft[source].partsOfSpeech.length) {
                    delete ft[source];
                }
            }

            state.filteredThesaurus = JSON.parse(JSON.stringify(ft));
        },
        applyUniqueWordsFilter(state, isUnique = false) {
            const ft = JSON.parse(JSON.stringify(state.filteredThesaurus));

            for (let source in ft) {
                ft[source].partsOfSpeech.forEach(pos => {
                    pos.definitions.forEach(definition => {
                        definition.synonyms = definition.synonyms.filter(
                            synonym => synonym.word.common === isUnique
                        );

                        definition.antonyms = definition.antonyms.filter(
                            antonym => antonym.common === isUnique
                        );
                    });
                });

                /**
                 * We need this part in case when Common Words filter is
                 * applied after Antonyms one in order to hide source if
                 * there are no Common Words among Antonyms
                 */
                if (state.isAntonymFilterActive) {
                    ft[source] = filterSourceByAntonyms(ft[source]);

                    if (!ft[source].partsOfSpeech.length) {
                        delete ft[source];
                    }
                }
            }

            state.filteredThesaurus = JSON.parse(JSON.stringify(ft));
        },
        initAntonymFilter(state) {
            let hasAntonymFilter = false;
            const ft = JSON.parse(JSON.stringify(state.filteredThesaurus));

            for (let source in ft) {
                ft[source].partsOfSpeech.forEach(pos => {
                    pos.definitions.forEach(definition => {
                        if (definition.antonyms.length) {
                            hasAntonymFilter = true;
                        }
                    });
                });
            }

            if (hasAntonymFilter) {
                state.filters.additional.push("antonymFilter");
            }
        },
        applyAntonymFilter(state) {
            const ft = JSON.parse(JSON.stringify(state.filteredThesaurus));

            for (let source in ft) {
                ft[source] = filterSourceByAntonyms(ft[source]);

                if (!ft[source].partsOfSpeech.length) {
                    delete ft[source];
                }
            }

            state.filteredThesaurus = JSON.parse(JSON.stringify(ft));
        }
    },
    getters: {
        getThesaurusHeadword: state => state.thesaurusHeadword,
        getThesaurus: state => state.filteredThesaurus,
        getSortedAZThesaurus: state => state.sortedAZThesaurus,
        getFilters: state => state.filters,
        isPosFilterActive: state => state.isPosFilterActive,
        isAZFilterActive: state => state.isAZFilterActive,
        isAntonymFilterActive: state => state.isAntonymFilterActive,
        isThesaurusLoaded: state => state.isThesaurusLoaded
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/ThesaurusFilterModule.js